import React from 'react';
import moment from 'moment';
import {Grid} from 'semantic-ui-react';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {shape, string, number} from 'prop-types';
import {formatLocalDateTime} from 'utils/DBUtils';
import {LocalDateTimePropType} from '../utils';

const dateFormat = 'M/DD/YYYY';

const Row = ({labelKey, currency, value}) => (
  <Grid.Row>
    <Grid.Column>
      <FormattedMessage id={labelKey} />
    </Grid.Column>
    <Grid.Column>
      <FormattedNumber
        style='currency'
        currency={currency}
        value={value} />
    </Grid.Column>
  </Grid.Row>
);

const TotalsOverview = props => (
  <div className='totals-overview'>
    <Grid columns={1}>
      <Grid.Row>
        <Grid.Column>
          <div className='totals-overview-content'>
            <div className='totals-overview-date'>
              <FormattedMessage
                id='rewardsStore.table.overview.startDate'
                values={{startDate: formatLocalDateTime(props.escrow.startDate, dateFormat)}} />
            </div>
            <div className='totals-overview-date'>
              <FormattedMessage
                id='rewardsStore.table.overview.endDate'
                values={{endDate: formatLocalDateTime(props.escrow.endDate, dateFormat)}} />
            </div>
            <Grid columns={2} className='totals-overview-quantities'>
              <Row
                labelKey='rewardsStore.table.overview.budget'
                currency={props.currency}
                value={props.escrow.budget} />
              <Row
                labelKey='rewardsStore.table.overview.allocated'
                currency={props.currency}
                value={props.escrow.allocated} />
              <Row
                labelKey='rewardsStore.table.overview.purchased'
                currency={props.currency}
                value={props.escrow.purchased} />
              <Row
                labelKey='rewardsStore.table.overview.available'
                currency={props.currency}
                value={props.escrow.available} />
            </Grid>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

TotalsOverview.propTypes = {
  currency: string.isRequired,
  escrow: shape({
    budget: number.isRequired,
    allocated: number.isRequired,
    purchased: number.isRequired,
    available: number.isRequired,
    startDate: LocalDateTimePropType.isRequired,
    endDate: LocalDateTimePropType.isRequired
  }).isRequired
};

export default TotalsOverview;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/TotalsOverview.jsx